import { IContact } from './contact';

export interface IContactTemp {
    id: number;
    lastName: string;
    firstName: string;
    company: string;
    title: string;
    email: string;
    isCenterContact: boolean;
    isVendorContact: boolean;
    isVipTagged: boolean;
    isNdd: boolean;
    linkedContact: IContact;
    insertedContactId: number;
}